// Central site-level SEO / branding constants.
// SITE_URL is the canonical production origin used in canonical tags, sitemap,
// and structured data. Override with REACT_APP_SITE_URL at build time if needed.

export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://electromax.ca"
).replace(/\/$/, "");

export const BUSINESS = {
  name: "ElectroMax Systems",
  legalName: "ElectroMax Electrical Ltd.",
  tagline: "Vancouver's Power Experts",
  phone: "604-754-1050",
  phoneE164: "+16047541050",
  email: "info@electromax.ca",
  streetAddress: "11045 78 Ave",
  addressLocality: "Delta",
  addressRegion: "BC",
  postalCode: "V4C 1N6",
  addressCountry: "CA",
  latitude: 49.1236,
  longitude: -122.9095,
  areasServed: [
    "Vancouver", "Burnaby", "Richmond", "Surrey", "Langley", "Coquitlam",
    "Delta", "North Vancouver", "West Vancouver", "Maple Ridge",
    "Abbotsford", "New Westminster",
  ],
  priceRange: "$$",
  openingHours: "Mo-Fr 07:00-18:00",
  logo: "/electromax-logo-dark.png",
  socialSameAs: [
    // Populate when live
  ],
  aggregateRating: {
    ratingValue: 5.0,
    reviewCount: 187,
  },
};
